import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useBroker} from "../session/useBroker";
import BrokerTopBar from "./BrokerTopBar";
import "../styles/workspace.css";

const ACCOUNT_NOTICE = {
    PENDING: ["warn", "Your account is waiting for approval. Our team usually reviews new partners within a working day; you'll get an email. You can look around, but adding listings unlocks once you're approved."],
    REJECTED: ["error", "Your registration wasn't approved. Contact info@oneglobalmarketplace.com if you think this is a mistake."],
    SUSPENDED: ["error", "Your account is suspended and your listings are hidden. Contact info@oneglobalmarketplace.com."],
};

/** Every signed-in broker page: redirects to login without a session, shows the top bar and the account status. */
const Workspace = ({children}) => {
    const navigate = useNavigate();
    const session = useBroker();
    const {loading, broker, error, logout} = session;

    useEffect(() => {
        if (!loading && !broker && !error) navigate("/broker/login", {replace: true});
    }, [loading, broker, error, navigate]);

    if (loading || (!broker && !error)) {
        return <div className="brk-shell"><div className="brk-loading">Loading your workspace…</div></div>;
    }
    if (!broker) {
        return (
            <div className="brk-shell">
                <div className="brk-main"><div className="brk-notice brk-notice--error" role="alert">{error}</div></div>
            </div>
        );
    }
    const notice = ACCOUNT_NOTICE[broker.status];
    return (
        <div className="brk-shell">
            <BrokerTopBar broker={broker} onLogout={logout}/>
            <main className="brk-main">
                {notice && <div className={`brk-notice brk-notice--${notice[0]}`} role="status">{notice[1]}</div>}
                {typeof children === "function" ? children(session) : children}
            </main>
        </div>
    );
};

export default Workspace;
